import routes from '@/routes/index';
import { Provider } from 'react-redux';
import { useRoutes } from 'react-router-dom';
import store from './store';
import GlobalLoader from './components/Loader/GlobalLoader';
import GoogleAds from './components/GoogleAds';

const App = () => {
  const element = useRoutes(routes);

  return (
    <>
      <Provider store={store}>
        <GoogleAds />
        <GlobalLoader />
        {element}
      </Provider>
    </>
  );
};

export default App;
